<div #tooltip class="tooltip-container" [innerHTML]="text | safe: 'html'"></div>
